export default "/images/filter-banner.png?4e0db93acdfefab2e560b744d5ca2c92";